module.exports = __webpack_public_path__ + "img/icon-bus.2d079e3b.svg";